import { render, staticRenderFns } from "./AdminOfferStatusesForm.vue?vue&type=template&id=1852b306"
import script from "./AdminOfferStatusesForm.vue?vue&type=script&lang=js"
export * from "./AdminOfferStatusesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports